import { useState, useEffect } from 'react';

// Ölkə kodu seçimli telefon input — hər ölkənin öz rəqəm sayına görə yoxlanır.
// Azərbaycan default seçili. onChange(fullDigits, isValid) qaytarır:
//   fullDigits = dial + milli nömrə (rəqəmlər, məs. "994501234567"), boşdursa "".
//
// AZ üçün operator kodları QF sistemi ilə eyni saxlanılır (auto-insert uğurlu olsun).

export const COUNTRIES = [
    { code: 'AZ', name: 'Azərbaycan',    dial: '994', flag: '🇦🇿', min: 9,  max: 9,  prefixes: ['10','40','50','51','55','60','70','77','99'], group: [2,3,2,2] },
    { code: 'TR', name: 'Türkiyə',       dial: '90',  flag: '🇹🇷', min: 10, max: 10 },
    { code: 'RU', name: 'Rusiya',        dial: '7',   flag: '🇷🇺', min: 10, max: 10 },
    { code: 'GE', name: 'Gürcüstan',     dial: '995', flag: '🇬🇪', min: 9,  max: 9  },
    { code: 'UA', name: 'Ukrayna',       dial: '380', flag: '🇺🇦', min: 9,  max: 9  },
    { code: 'AE', name: 'BƏƏ',           dial: '971', flag: '🇦🇪', min: 8,  max: 9  },
    { code: 'IR', name: 'İran',          dial: '98',  flag: '🇮🇷', min: 10, max: 10 },
    { code: 'SA', name: 'S. Ərəbistan',  dial: '966', flag: '🇸🇦', min: 9,  max: 9  },
    { code: 'QA', name: 'Qətər',         dial: '974', flag: '🇶🇦', min: 8,  max: 8  },
    { code: 'IL', name: 'İsrail',        dial: '972', flag: '🇮🇱', min: 9,  max: 9  },
    { code: 'US', name: 'ABŞ / Kanada',  dial: '1',   flag: '🇺🇸', min: 10, max: 10 },
    { code: 'GB', name: 'B. Britaniya',  dial: '44',  flag: '🇬🇧', min: 10, max: 10 },
    { code: 'DE', name: 'Almaniya',      dial: '49',  flag: '🇩🇪', min: 10, max: 11 },
    { code: 'FR', name: 'Fransa',        dial: '33',  flag: '🇫🇷', min: 9,  max: 9  },
];

export const validatePhone = (country, nationalDigits) => {
    const d = String(nationalDigits || '').replace(/\D/g, '');
    if (!country) return false;
    if (d.length < country.min || d.length > country.max) return false;
    if (country.prefixes && !country.prefixes.some(p => d.startsWith(p))) return false;
    return true;
};

// Milli nömrəni ölkəyə görə qruplayıb göstər (AZ: 50 123 45 67)
const formatNational = (country, digits) => {
    const d = String(digits || '').replace(/\D/g, '').slice(0, country.max);
    if (country.group) {
        const parts = [];
        let i = 0;
        for (const n of country.group) { if (i >= d.length) break; parts.push(d.slice(i, i + n)); i += n; }
        if (i < d.length) parts.push(d.slice(i));
        return parts.filter(Boolean).join(' ');
    }
    return d.replace(/(\d{3})(?=\d)/g, '$1 ').trim();
};

export default function PhoneInput({ onChange, defaultCode = 'AZ', className = '' }) {
    const [code, setCode] = useState(defaultCode);
    const [national, setNational] = useState('');
    const country = COUNTRIES.find(c => c.code === code) || COUNTRIES[0];

    useEffect(() => {
        const digits = national.replace(/\D/g, '');
        const valid = validatePhone(country, digits);
        onChange?.(digits ? country.dial + digits : '', valid);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [code, national]);

    return (
        <div className={`flex gap-2 ${className}`}>
            <select
                value={code}
                onChange={(e) => { setCode(e.target.value); setNational(''); }}
                className="shrink-0 rounded-xl border border-gray-200 bg-white px-2 py-2.5 text-sm focus:outline-none"
                aria-label="Ölkə kodu"
            >
                {COUNTRIES.map(c => (
                    <option key={c.code} value={c.code}>{c.flag} +{c.dial}</option>
                ))}
            </select>
            <div className="flex min-w-0 flex-1 items-center rounded-xl border border-gray-200 px-3 focus-within:border-gray-400">
                <span className="mr-1 shrink-0 font-mono text-sm text-gray-400">+{country.dial}</span>
                <input
                    type="tel"
                    inputMode="numeric"
                    value={formatNational(country, national)}
                    onChange={(e) => setNational(e.target.value.replace(/\D/g, '').slice(0, country.max))}
                    placeholder={country.code === 'AZ' ? '50 123 45 67' : 'Telefon nömrəsi'}
                    className="min-w-0 flex-1 bg-transparent py-2.5 font-mono text-sm outline-none"
                />
            </div>
        </div>
    );
}
